(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CountryStateByCode', CountryStateByCode);

    CountryStateByCode.$inject = ['$resource'];

    function CountryStateByCode ($resource) {
        var resourceUrl =  'api/states/:code';

        return $resource(resourceUrl, {code: '@code'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
